import { ref, computed } from 'vue';
import { useStore } from 'vuex';

// Click-to-filter state for a single-selection visual: clicking a mark applies
// this visual's cross-filter, clicking the same mark again clears it, and
// `sync()` drops the local highlight when another visual reset the context.
export function useSelectableFilter(chartName) {
  const store = useStore();
  const selected = ref(null);
  const filterContext = computed(() => store.state.filterContext);

  const hasSelection = computed(() => selected.value !== null);
  const isSelected = (key) => selected.value === key;

  // Call at the top of every rebuild.
  const sync = () => {
    const active = filterContext.value?.filters || {};
    if (selected.value !== null && active[chartName] === undefined) {
      selected.value = null;
    }
  };

  const toggleWithQuery = async (key, query, label = null) => {
    const context = filterContext.value;
    if (!context) return;
    if (selected.value === key) {
      selected.value = null;
      await context.removeFilter(chartName);
      return;
    }
    selected.value = key;
    await context.updateFilterWithQuery(chartName, query, label);
  };

  const toggle = (key, condition, label = null) =>
    toggleWithQuery(key, `SELECT assetKey FROM unique_assets WHERE ${condition}`, label);

  const clear = async () => {
    selected.value = null;
    await filterContext.value?.removeFilter(chartName);
  };

  return { selected, hasSelection, isSelected, sync, toggle, toggleWithQuery, clear };
}
